import React from 'react'
import { EnvironmentTitle, HeroPanel, DetailTilesContainer } from 'view/shared/heroPanel'
import { Locale, Translation } from 'locale'

export const TradingControlViewHeroPanel: React.FunctionComponent = () => (
  <HeroPanel>
    <DetailTilesContainer>
      <EnvironmentTitle data-test-id={'TradingControlViewHeroPanel-EnvironmentTitle'}>
        {Locale.translate(Translation.TC_HERO_TRADING_CONTROL_LIMITS)}
      </EnvironmentTitle>
    </DetailTilesContainer>
  </HeroPanel>
)
